import React from 'react';
import cn from 'classnames';
import MetaText from "../../ui/Typography/texts/MetaText";
import { filterHiddenSustainabilityMarkers } from './helper/filterHiddenSustainabilityMarkers';
import styles from './ProductMarkers.module.scss';
function getSustainabilityMarkerIds() {
    if (typeof window !== 'undefined') {
        return window.sustainabilityMarkerIds;
    }
    return undefined;
}
const ProductMarkers = ({ markers, selection, hasOneMarkerPerLine = false, wrapperClassName, marketingMarkerSpacing, isProductMarkerCentered = false, shouldReserveMarkerSpace = false, productMarkerClassName, }) => {
    if (!markers && !selection && !shouldReserveMarkerSpace)
        return null;
    return (React.createElement("div", { className: cn(wrapperClassName, hasOneMarkerPerLine && styles.oneMarkerPerLineWrap, isProductMarkerCentered && styles.textCentered) },
        markers &&
            filterHiddenSustainabilityMarkers(markers, getSustainabilityMarkerIds()).map(({ text = '', type = '' }) => text.split(',').map((markerLabel) => (React.createElement(React.Fragment, null,
                React.createElement(MetaText, { key: markerLabel, className: cn(styles.marketingMarkers, styles[type], marketingMarkerSpacing && styles[marketingMarkerSpacing], productMarkerClassName) }, markerLabel))))),
        selection && React.createElement(MetaText, { className: styles.marketingMarkers }, selection)));
};
export default ProductMarkers;
//# sourceMappingURL=ProductMarkers.js.map